import SectionHeader from "@/components/feature/panel/SectionHeader";
import EmptyState from "@/components/feature/panel/EmptyState";
import PanelLinks from "@/components/feature/panel/PanelLinks";
import { getDataClient } from "@/lib/dataClient";
import { useDataQuery } from "@/hooks/useDataQuery";

interface ExamRow {
  id: number;
  title: string;
  exam_type: string | null;
  mode: string;
  question_count: number;
  duration_minutes: number | null;
  created_at: string;
}

const modeLabel: Record<string, string> = {
  test: "Test",
  deneme: "Deneme",
};

function formatDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString("tr-TR", { day: "numeric", month: "short", year: "numeric" });
}

export default function AdminSinavlar() {
  const { data, loading, error, reload } = useDataQuery<ExamRow[]>(async () => {
    const dataClient = getDataClient();
    const { data, error } = await dataClient
      .from("exams")
      .select("id, title, exam_type, mode, question_count, duration_minutes, created_at")
      .order("created_at", { ascending: false });
    if (error) throw error;
    return (data ?? []) as ExamRow[];
  });

  return (
    <div className="space-y-6">
      <SectionHeader
        title="Sınavlar"
        description="Oluşturulan test ve deneme kayıtlarını görüntüle."
      />

      {loading ? (
        <EmptyState icon="ri-loader-4-line" title="Yükleniyor..." />
      ) : error ? (
        <div className="rounded-lg border border-background-200 bg-background-50 p-6 text-center">
          <p className="text-sm text-foreground-600">{error}</p>
          <button
            type="button"
            onClick={reload}
            className="mt-4 inline-flex items-center gap-2 whitespace-nowrap px-4 py-2 rounded-md text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
          >
            <i className="ri-refresh-line" aria-hidden="true"></i>
            Tekrar dene
          </button>
        </div>
      ) : !data || data.length === 0 ? (
        <EmptyState
          icon="ri-file-list-3-line"
          title="Henüz sınav kaydı yok"
          description="Öğretmenler test veya deneme oluşturdukça burada listelenecek."
        />
      ) : (
        <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          <table className="w-full text-left text-sm">
            <thead>
              <tr className="border-b border-background-200 bg-background-100">
                <th className="px-4 py-3 font-semibold text-foreground-700">Başlık</th>
                <th className="px-4 py-3 font-semibold text-foreground-700">Tür</th>
                <th className="px-4 py-3 font-semibold text-foreground-700">Sınav</th>
                <th className="px-4 py-3 font-semibold text-foreground-700 text-right">Soru</th>
                <th className="px-4 py-3 font-semibold text-foreground-700 text-right">Süre</th>
                <th className="px-4 py-3 font-semibold text-foreground-700 text-right">Tarih</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-background-200">
              {data.map((e) => (
                <tr key={e.id}>
                  <td className="px-4 py-3 text-foreground-900">{e.title}</td>
                  <td className="px-4 py-3">
                    <span className="inline-flex items-center rounded-full bg-secondary-100 text-secondary-900 px-2.5 py-0.5 text-xs font-semibold">
                      {modeLabel[e.mode] ?? e.mode}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-foreground-600">{e.exam_type ?? "—"}</td>
                  <td className="px-4 py-3 text-foreground-600 text-right">{e.question_count}</td>
                  <td className="px-4 py-3 text-foreground-600 text-right">
                    {e.duration_minutes != null ? `${e.duration_minutes} dk` : "—"}
                  </td>
                  <td className="px-4 py-3 text-foreground-600 text-right whitespace-nowrap">
                    {formatDate(e.created_at)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <PanelLinks
        links={[
          { label: "Canlı Dersler", href: "/yonetici/canli-dersler", icon: "ri-vidicon-line" },
          { label: "İçerik Yönetimi", href: "/yonetici/icerikler", icon: "ri-stack-line" },
        ]}
      />
    </div>
  );
}